import React from "react"
import ZoomIcon from "components/zoom_icon"
import PropTypes from "prop-types"
import LoadingImage from "./loading_image"

const OverviewImage = ({
  image_width,
  image_height,
  image_url,
  alt_text,
  fullscreen_url,
  caption = {},
  allow_fullscreen
}) => (
  <figure className="overview-image">
    <ZoomIcon
      images={[{image_url, fullscreen_url}]}
      allow_fullscreen={allow_fullscreen}
      source="learning path overview image"
    />
    <LoadingImage
      image_url={image_url}
      width={image_width}
      height={image_height}
      alt_text={alt_text}
    />
    {(caption.title || caption.description) &&
      <figcaption>
        {!!caption.title &&
          <div
            className="overview-image__title"
            dangerouslySetInnerHTML={{__html: caption.title}}
          ></div>}
        {!!caption.description &&
          <div dangerouslySetInnerHTML={{__html: caption.description}}></div>}
      </figcaption>}
  </figure>
)

OverviewImage.propTypes = {
  image_width: PropTypes.number,
  image_height: PropTypes.number,
  image_url: PropTypes.string.isRequired,
  alt_text: PropTypes.string,
  fullscreen_url: PropTypes.string,
  caption: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string
  }),
  allow_fullscreen: PropTypes.bool.isRequired
}

export default OverviewImage
